import { render, staticRenderFns } from "./PackagePremium.vue?vue&type=template&id=6e166ae0&"
import script from "./PackagePremium.vue?vue&type=script&lang=js&"
export * from "./PackagePremium.vue?vue&type=script&lang=js&"
import style0 from "./PackagePremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackagePremium.vue"
export default component.exports